import { validateOpenAPI } from "@/lib/openapi-conversion"
import { Tables } from "@/supabase/types"
import { PermAction } from "@/types/base/permissions"
import { concatLine, isEmpty, isNotEmpty } from "@/utils/string_utils"

export const validateAssistants = (assistant: Tables<"assistants">, _action: PermAction):string | null => {
	let msg = ''
	if (isEmpty(assistant.name)) {
		msg = concatLine(msg, "Name is required")
	}
	if (isEmpty(assistant.prompt)) {
		msg = concatLine(msg, "Prompt is required")
	}
	if (isEmpty(msg)) {
		return null
	}
	return msg
}

export const validateChats = (_chat: Tables<"chats">, _action: PermAction):string | null => {
	return null //nothing to validate
}

export const validateCollections = (collection: Tables<"collections">, _action: PermAction):string | null => {
	let msg = ''
	if (isEmpty(collection.name)) {
		msg = concatLine(msg, "Name is required")
	}
	if (isEmpty(msg)) {
		return null
	}
	return msg
}

export const validateFiles = (file: Tables<"files">, action: PermAction):string | null => {
	let msg = ''
	if (isEmpty(file.name)) {
		msg = concatLine(msg, "Name is required")
	}
	if (action == PermAction.create && file.size <= 0) {
		msg = concatLine(msg, "A File is required")
	}
	if (isEmpty(msg)) {
		return null
	}
	return msg
}

export const validateGroups = (group: Tables<"groups">, _action: PermAction):string | null => {
	let msg = ''
	if (isEmpty(group.name)) {
		msg = concatLine(msg, "Name is required")
	}
	if (isEmpty(msg)) {
		return null
	}
	return msg
}

export const validateModels = (model: Tables<"models">, _action: PermAction):string | null => {
	let msg = ''
	if (isEmpty(model.name)) {
		msg = concatLine(msg, "Name is required")
	}
	if (isEmpty(model.model_id)) {
		msg = concatLine(msg, "Model Id is required")
	}
	if (isEmpty(model.provider_id) && isEmpty(model.base_url)) {
		msg = concatLine(msg, "Base URL is required")
	}
	if (isEmpty(model.provider_id) && isEmpty(model.api_key)) {
		msg = concatLine(msg, "API Key is required")
	}
	if (isEmpty(msg)) {
		return null
	}
	return msg
}

export const validatePresets = (preset: Tables<"presets">, _action: PermAction):string | null => {
	let msg = ''
	if (isEmpty(preset.name)) {
		msg = concatLine(msg, "Name is required")
	}
	if (isEmpty(preset.prompt)) {
		msg = concatLine(msg, "Prompt is required")
	}
	if (isEmpty(msg)) {
		return null
	}
	return msg
}

export const validateProfiles = (profile: Tables<"profiles">, _action: PermAction):string | null => {
	let msg = ''
	if (isEmpty(profile.username)) {
		msg = concatLine(msg, "Username is required")
	}
	if (isEmpty(msg)) {
		return null
	}
	return msg
}

export const validatePrompts = (prompt: Tables<"prompts">, _action: PermAction):string | null => {
	let msg = ''
	if (isEmpty(prompt.name)) {
		msg = concatLine(msg, "Name is required")
	}
	if (isEmpty(prompt.content)) {
		msg = concatLine(msg, "Prompt content is required")
	}
	if (isEmpty(msg)) {
		return null
	}
	return msg
}

export const validateProviders = (provider: Tables<"providers">, _action: PermAction):string | null => {
	let msg = ''
	if (isEmpty(provider.name)) {
		msg = concatLine(msg, "Name is required")
	}
	if (isEmpty(provider.description)) {
		msg = concatLine(msg, "Description is required")
	}
	if (isEmpty(msg)) {
		return null
	}
	return msg
}

export const validateRoles = (_role: Tables<"roles">, _action: PermAction):string | null => {
	return null //nothing to validate since can't create or edit
}

export const validateTenants = (tenant: Tables<"tenants">, _action: PermAction):string | null => {
	let msg = ''
	if (isEmpty(tenant.name)) {
		msg = concatLine(msg, "Name is required")
	}
	if (isEmpty(tenant.admin_email)) {
		msg = concatLine(msg, "Admin email is required")
	}
	if (isEmpty(msg)) {
		return null
	}
	return msg
}

export const validateMcps = (mcp: Tables<"mcps">, _action: PermAction):string | null => {
	let msg = ''
	if (isEmpty(mcp.name)) {
		msg = concatLine(msg, "Name is required")
	}
	if (isNotEmpty(mcp.custom_headers as string)) {
		try {
			JSON.parse(mcp.custom_headers as string)
		}
		catch (error) {
			msg = concatLine(msg, "Header invalid JSON format")
		}
	}
	if (isEmpty(msg)) {
		return null
	}
	return msg
}

export const validateTools = (tool: Tables<"tools">, _action: PermAction):string | null => {
	let msg = ''
	if (isEmpty(tool.name)) {
		msg = concatLine(msg, "Name is required")
	}
	if (isNotEmpty(tool.custom_headers as string)) {
		try {
			JSON.parse(tool.custom_headers as string)
		}
		catch (error) {
			msg = concatLine(msg, "Header invalid JSON format")
		}
	}
	if (isEmpty(tool.schema as string)) {
		msg = concatLine(msg, "Schema is required")
	}
	else {
		try {
			const parsedSchema = JSON.parse(tool.schema as string)
			validateOpenAPI(parsedSchema)
				.catch(error => msg = concatLine(msg, error.message)) // Set specific validation error message
		}
		catch (error) {
			msg = concatLine(msg, "Schema Invalid JSON format")
		}
	}
	if (isEmpty(msg)) {
		return null
	}
	return msg
}

